import{_ as a}from"./_getNative-9aa37f67.js";import{b as e}from"./_baseGetTag-852b3600.js";var r=a(e,"WeakMap");export{r as _};
//# sourceMappingURL=_WeakMap-b38d8ef4.js.map
